export interface RecipeConsumePreviewInput {
  ingredientId: number;
  productId: number;
  requiredAmount: number;
  availableStockAmount: number;
}

export interface RecipeConsumePreviewItem extends RecipeConsumePreviewInput {
  defaultSelected: boolean;
  consumeAmount: number;
  isPartial: boolean;
}

export function buildRecipeConsumePreviewItems(
  items: RecipeConsumePreviewInput[],
): RecipeConsumePreviewItem[] {
  const remainingStockByProductId = new Map<number, number>();

  return items.map((item) => {
    const requiredAmount = Math.max(item.requiredAmount, 0);
    const availableStockAmount = Math.max(item.availableStockAmount, 0);
    const remainingStockAmount = remainingStockByProductId.get(
      item.productId,
    ) ?? availableStockAmount;
    const consumeAmount = Math.min(requiredAmount, remainingStockAmount);

    remainingStockByProductId.set(
      item.productId,
      Math.max(remainingStockAmount - consumeAmount, 0),
    );

    return {
      ...item,
      requiredAmount,
      availableStockAmount,
      defaultSelected: consumeAmount > 0,
      consumeAmount,
      isPartial: consumeAmount > 0 && consumeAmount < requiredAmount,
    };
  });
}

export function getRecipeConsumePreviewText(
  item: RecipeConsumePreviewItem,
  selected: boolean,
): string {
  if (!selected) return "Will not consume";
  if (item.consumeAmount <= 0) return "No stock to consume";
  if (item.isPartial) return "Will consume available stock only";
  return "Will consume required amount";
}
